var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0726 3.73455C20.6826 0.874547 19.8126 0.394479 17.0326 0.164479C15.2926 0.0144786 13.5326 0.0244444 11.7826 0.00444444C10.9326 0.00444444 10.0726 -0.00555556 9.22257 0.00444444C7.38257 0.0344444 5.40258 0.0344347 3.57258 0.244435C0.912575 0.554435 0.432581 1.49448 0.172581 4.04448C-0.0474185 6.18448 -0.0674185 8.62446 0.172581 10.7745C0.442581 13.2445 0.872589 14.2745 3.49259 14.5745C5.31259 14.7845 7.30258 14.7845 9.14258 14.8145C10.2626 14.8345 11.3926 14.8345 12.5026 14.8145C14.2626 14.7845 16.1526 14.7845 17.9026 14.5645C20.3426 14.2545 20.7726 13.3144 21.0626 11.0044C21.3326 8.82444 21.3626 5.91455 21.0626 3.73455H21.0726ZM8.37256 10.8545V3.95452L14.3926 7.40447L8.37256 10.8545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.271adf525cc86a7f5daa507968c2c33a.svg";
export { ForwardRef as ReactComponent };